@if (paragraphData) {
  <mat-card class="paragraph" [ngClass]="styleClasses">
    <div [innerHTML]="paragraphData"></div>
  </mat-card>
}
